<div class="main-popup-div">
    <div class="popup-heding">
        <div>
            <h1 class="heading-text">
                Get Report
            </h1>
        </div>
        <div (click)="cancel(null)">
            <mat-icon class="clear-icon" style="font-size: medium;">clear</mat-icon>
        </div>
    </div>
</div>
<div *ngIf="isLoading">
    <div class="center-loading">
        <mat-progress-spinner mode="indeterminate" diameter="40" style="margin:0 auto;">
        </mat-progress-spinner>
    </div>
</div>
<div class="popup-body">
    <form name="editUserForm" [formGroup]="generateReportForm">


        <label for="reportType" class="label required">Select Type</label>
        <select id="reportType" name="reportType" class="input-style" formControlName="reportType"
            (change)="onDurationSelectionChange($event)">
            <option value="Select Type" selected disabled>Select Type</option>
            <option *ngFor="let type of listOfReportType" [value]="type">
                {{type}}</option>
        </select>


        <label for="type" class="label required">File Name</label>
        <input type="text" placeholder="Enter File Name" id="fileName" formControlName="fileName" class="input-style">


        <label for="duration" class="label required">Select Duration</label>
        <select id="duration" name="duration" class="input-style" formControlName="duration"
            (change)="onDurationSelectionChange($event)">
            <option value="Select Duration" selected disabled>Select Duration</option>
            <option *ngFor="let duration of listOfDuration" [value]="duration['days']">
                {{duration['label']}}</option>
        </select>


        <label for="type" class="label required">Start Date</label>
        <input type="date" placeholder="Start Date" id="startDate" formControlName="startDate" [max]="maxStartDate"
            class="input-style" (input)="startDateChange($event)">

        <label for="type" class="label required">End Date</label>
        <input type="date" placeholder="End Date" id="endDate" [min]="minEndDate" formControlName="endDate"
            class="input-style" (input)="endDateChange($event)">

        <div class="save">
            <input type="submit"
                [ngClass]="{'save-btn-disabled':generateReportForm.invalid  ,'save-btn':generateReportForm.valid }"
                value="{{'Save'}}" [disabled]="generateReportForm.invalid" (click)="getReport()" />
        </div>
    </form>
</div>